import { useLocalStorageJsonState } from "./stateHooks";
import { useIsVisible } from "./staticDataHooks";
import { useState, useEffect, useLayoutEffect } from "react";

export const useIsFullWidth = () => {
  const nonPersistedState = useState(false);
  const persistedState = useLocalStorageJsonState("isFullWidth", {
    default: false,
  });

  const { isVisible: isPersistentFullWidth } = useIsVisible(
    "persistentFullWidth"
  );

  const [isFullWidth, setIsFullWidth] = isPersistentFullWidth
    ? persistedState
    : nonPersistedState;

  const toggleIsFullWidth = () => {
    setIsFullWidth(!isFullWidth);
  };

  return {
    isFullWidth,
    setIsFullWidth,
    toggleIsFullWidth,
  };
};

export const useShowFullWidthAction = () => {
  const [
    showFullWidthAction,
    setShowFullWidthAction,
  ] = useLocalStorageJsonState("showFullWidthAction", { default: false });

  const toggleShowFullWidthAction = () =>
    setShowFullWidthAction(!showFullWidthAction);

  return {
    showFullWidthAction,
    setShowFullWidthAction,
    toggleShowFullWidthAction,
  };
};

export const useHasStickyHeaders = () => {
  const [
    hasStickyHeaders,
    setHasStickyHeaders,
  ] = useLocalStorageJsonState("hasStickyHeaders", { default: false });

  const toggleHasStickyHeaders = () => setHasStickyHeaders(!hasStickyHeaders);

  return {
    hasStickyHeaders,
    setHasStickyHeaders,
    toggleHasStickyHeaders,
  };
};

export const useSidebar = (isOpen) => {
  const [top, setTop] = useState(0);

  useLayoutEffect(() => {
    const updateDrawerPosition = () => {
      const el = document.body.querySelector(".app-bar");
      const offset = Math.ceil(Math.max(el.getBoundingClientRect().bottom, 0));
      setTop(offset);
    };

    window.addEventListener("scroll", updateDrawerPosition);
    updateDrawerPosition();

    return () => window.removeEventListener("scroll", updateDrawerPosition);
  }, []);

  useEffect(() => {
    return () => document.body.classList.remove("has-sidebar");
  }, []);

  useEffect(() => {
    isOpen
      ? document.body.classList.add("has-sidebar")
      : document.body.classList.remove("has-sidebar");
  }, [isOpen]);

  return { top };
};
